"use client";
import { useState, useRef } from "react";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollProgress from "@/components/scroll-progress";
import Chatbot from "@/components/chatbot";

export default function ClientLayout({ header, children, footer }) {
  const [openLink, setOpenLink] = useState(null);
  const scrollContainerRef = useRef(null);

  return (
    <div
      ref={scrollContainerRef}
      className="h-screen flex flex-col overflow-y-auto overflow-x-hidden"
    >
      <ScrollProgress scrollContainerRef={scrollContainerRef} />
      {/* <Chatbot /> */}
      <Header openLink={openLink} setOpenLink={setOpenLink} header={header} />
      <main className="flex-grow">{children}</main>
      <Footer data={footer} />
    </div>
  );
}
